import store from '@/store';
import i18n from '@/i18n';
let Mixins = {
    displayErrors(errors){
        let errorArray = [];
        
        // COMBINE ALL MESSAGES
        for(let error in errors){
            errorArray = errorArray.concat(errors[error]);
        }

        // CREATE HTML FOR MESSAGES
        let messages = '';
        for(let message in errorArray){
            messages += ('<li>' + errorArray[message] + '</li>');
        }
        swal({
            title: this.$t('error'),
            type: 'warning',
            buttonsStyling: false,
            confirmButtonClass: 'button button--transparent button-border-blue',
            html: '<ul>' + messages + '</ul>'
        });
        return errorArray;
    }

};

export default Mixins;


// WEBPACK FOOTER //
// ./src/lib/mixins.js